export default function Overlay({ children }) {
  return <section className="overlay">{children}</section>;
}
